// UserPropertyDetailsFederatedPhotoErrorDto
const FederatedPhotoError = ({ errorCode = '', errorMessage = '', replacementPhotoId = '' } = {}) => ({
  errorCode: String(errorCode),
  errorMessage: String(errorMessage),
  replacementPhotoId: String(replacementPhotoId),
});

export default FederatedPhotoError;

export type FederatedPhotoErrorProps = ReturnType<typeof FederatedPhotoError>;
